import { render, staticRenderFns } from "./modal-voucher.vue?vue&type=template&id=489738e2&"
import script from "./modal-voucher.vue?vue&type=script&lang=js&"
export * from "./modal-voucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports